import React, { useCallback } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import ProcesosWorkflowPeriodosModal from './ProcesosWorkflowPeriodosModal';
import type { ProcesosOutletContext } from './procesos-periodo-page';
import {
  parseProcesosWorkflowId,
  procesosWorkflowListPath,
  readProcesosReturnSearch,
  type ProcesosWorkflowLocationState,
} from './procesos-workflow-routes';

export default function ProcesosWorkflowPeriodosModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const { workflowId: workflowIdParam } = useParams();
  const { refreshAfterPeriodoChange } = useOutletContext<ProcesosOutletContext>();
  const state = location.state as ProcesosWorkflowLocationState | null;
  const procesosReturnSearch = readProcesosReturnSearch(state);
  const returnPath = state?.returnPath || '/procesos';
  const workflowId = parseProcesosWorkflowId(location.pathname)
    ?? (Number(workflowIdParam) > 0 ? Number(workflowIdParam) : null);

  const handleClose = useCallback(() => {
    navigate(`${returnPath}${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch, returnPath]);

  const handleBack = useCallback(() => {
    navigate(procesosWorkflowListPath(procesosReturnSearch), {
      state: { procesosSearch: procesosReturnSearch, returnPath },
    });
  }, [navigate, procesosReturnSearch, returnPath]);

  if (workflowId == null) return null;

  return (
    <ProcesosWorkflowPeriodosModal
      open
      workflowId={workflowId}
      onClose={handleClose}
      onBack={handleBack}
      onProcesosCreated={refreshAfterPeriodoChange}
    />
  );
}
